import {
  ChangeDetectionStrategy,
  Component,
  input,
  output,
} from '@angular/core';
import { AlarmsCardComponent, EventsCardComponent, InfoCardComponent, TimerComponent } from '@ui';
import { TranslocoDirective } from '@jsverse/transloco';
import { PageHeaderComponent } from '../../atoms/page-header/page-header.component';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    PageHeaderComponent,
    TranslocoDirective,
    InfoCardComponent,
    TimerComponent,
    AlarmsCardComponent,
    EventsCardComponent
],
  selector: 'ui-distribution-network-header',
  template: `
    <ng-container *transloco="let t">
      <ui-page-header>
        <div class="col-span-1 sm:col-span-4 xl:col-span-6">
          <ui-info-card
            [title]="t('DISTRIBUTION_NETWORK.NAME')"
            icon="icons:dataflow"
          >
            <p class="text-gray-500">{{ t('DISTRIBUTION_NETWORK.LOCAL_TIME') }} <ui-timer /></p>
          </ui-info-card>
        </div>
        <div class="col-span-1 sm:col-span-4 xl:col-span-3">
          <ui-alarms-card
            [alarmsUnreadCount]="alarmsUnreadCount()"
            [alarmsActiveCount]="alarmsActiveCount()"
            (alarmsLinkClick)="handleAlarmsLinkClick()"
          />
        </div>
        <div class="col-span-1 sm:col-span-4 xl:col-span-3">
          <ui-events-card
            [eventsUnreadCount]="eventsUnreadCount()"
            (eventsLinkClick)="handleEventsLinkClick()"
          />
        </div>
      </ui-page-header>
    </ng-container>
  `,
})
export class DistributionNetworkHeaderComponent {
  eventsUnreadCount = input<number | null>(null);
  alarmsUnreadCount = input<number | null>(null);
  alarmsActiveCount = input<number | null>(null);

  alarmsLinkClick = output<void>();
  eventsLinkClick = output<void>();

  handleAlarmsLinkClick() {
    this.alarmsLinkClick.emit();
  }

  handleEventsLinkClick() {
    this.eventsLinkClick.emit();
  }
}
